// react
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// application
import departmentsAria from '../../services/departmentsArea';
import languages from '../../i18n';
import StroykaSlick from '../shared/StroykaSlick';

const slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
};

class BlockSlideShow extends Component {
    departmentsAreaRef = null;

    media = window.matchMedia('(min-width: 992px)');

    slides = [
        {
            title: {
                id: "slides.pets.title",
                defaultMessage: "Tout pour vos Amis à Fourrure"
            },
            text: {
                id: "slides.pets.text",
                defaultMessage: "Quality supplies to keep your pets happy, healthy, and thriving!"
            },
            image_classic: {
                ltr: '/images/slides/puppy.png',
                rtl: '/images/slides/puppy.png',
            },
            image_full: {
                ltr: '/images/slides/puppy.png',
                rtl: '/images/slides/puppy.png',
            },
            image_mobile: {
                ltr: '/images/slides/mobile-pouppy.png',
                rtl: '/images/slides/mobile-pouppy.png',
            },
            url : "/shop/catalog/pet-toys"

            
        },
        {
            title: {
                id: "slides.beauty.title",
                defaultMessage: "Plongez dans la Beauté & le Soin Personnel"
            },
            text: {
                id: "slides.beauty.text",
                defaultMessage: "Discover essentials that inspire confidence and self-care every day!"
            },
            image_classic: {
                ltr: '/images/slides/personal-care.png',
                rtl: '/images/slides/personal-care.png',
            },
            image_full: {
                ltr: '/images/slides/personal-care.png',
                rtl: '/images/slides/personal-care.png',
            },
            image_mobile: {
                ltr: '/images/slides/mobile-personal-care.png',
                rtl: '/images/slides/mobile-personal-care.png',
            },
            url : "/shop/catalog/personal-care"
        },
        {
            title: {
                id: "slides.toys.title",
                defaultMessage: "Découvrez l'Amusement sans Fin avec les Jouets & les Jeux"
            },
            text: {
                id: "slides.toys.text",
                defaultMessage: "Games for all ages, promising fun and discovery. Bring joy to kids and adults alike!"
            },
            image_classic: {
                ltr: '/images/slides/toysBanner.png',
                rtl: '/images/slides/toysBanner.png',
            },
            image_full: {
                ltr: '/images/slides/toysBanner.png',
                rtl: '/images/slides/toysBanner.png',
            },
            image_mobile: {
                ltr: '/images/slides/mobile-toys.png',
                rtl: '/images/slides/mobile-toys.png',
            },
            url : "/shop/catalog/toys-and-games"
        },
    ];

    componentDidMount() {
        if (this.media.addEventListener) {
            this.media.addEventListener('change', this.onChangeMedia);
        } else {
            // noinspection JSDeprecatedSymbols
            this.media.addListener(this.onChangeMedia);
        }
    }

    componentWillUnmount() {
        departmentsAria.area = null;

        if (this.media.removeEventListener) {
            this.media.removeEventListener('change', this.onChangeMedia);
        } else {
            // noinspection JSDeprecatedSymbols
            this.media.removeListener(this.onChangeMedia);
        }
    }

    onChangeMedia = () => {
        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    setDepartmentsAreaRef = (ref) => {
        this.departmentsAreaRef = ref;

        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    renderSlide = (slide, index) => {
        const { direction, withDepartments } = this.props;
        const image = withDepartments ? slide.image_classic[direction] : slide.image_full[direction];
        
        return (
            <div key={index} className="block-slideshow__slide">
                <div
                    className="block-slideshow__slide-image block-slideshow__slide-image--desktop"
                    style={{ backgroundImage: `url(${image})` }}
                />
                <div
                    className="block-slideshow__slide-image block-slideshow__slide-image--mobile"
                    style={{ backgroundImage: `url(${slide.image_mobile[direction]})` }}
                />
                <div className="block-slideshow__slide-content">
                    <div className="block-slideshow__slide-title">
                        <FormattedMessage {...slide.title} />
                    </div>
                    <div className="block-slideshow__slide-text">
                        <FormattedMessage {...slide.text} />
                    </div>
                    <div className="block-slideshow__slide-button">
                        <Link to={slide.url} className="btn btn-primary btn-lg">Shop Now</Link> 
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { locale, withDepartments } = this.props;
        const { direction } = languages[locale];

        const blockClasses = classNames(
            'block-slideshow block',
            {
                'block-slideshow--layout--full': !withDepartments,
                'block-slideshow--layout--with-departments': withDepartments,
            },
        );

        const layoutClasses = classNames(
            'col-12',
            {
                'col-lg-12': !withDepartments,
                'col-lg-9': withDepartments,
            },
        );

        const slides = this.slides.map((slide, index) => this.renderSlide(slide, index));

        return (
            <div className={blockClasses}>
                <div className="container">
                    <div className="row">
                        {withDepartments && (
                            <div className="col-3 d-lg-block d-none" ref={this.setDepartmentsAreaRef} />
                        )}

                        <div className={layoutClasses}>
                            <div className="block-slideshow__body">
                                <StroykaSlick {...slickSettings}>
                                    {slides}
                                </StroykaSlick>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BlockSlideShow.propTypes = {
    withDepartments: PropTypes.bool,
    /** current locale */
    locale: PropTypes.string,
};

BlockSlideShow.defaultProps = {
    withDepartments: false,
};

function mapStateToProps(state) {
    return {
        locale: state.locale,
        direction: languages[state.locale].direction
    };
}

export default connect(mapStateToProps)(BlockSlideShow);
